import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PublicLayout } from './PublicLayout';
import { AdminLayout } from './AdminLayout';
import { HomePage } from '../pages/public/HomePage';
import { SobreNosotrosPage } from '../pages/public/SobreNosotrosPage';
import { ContactoPage } from '../pages/public/ContactoPage';
import { FAQPage } from '../pages/public/FAQPage';
import { PoliticaEnviosPage } from '../pages/public/PoliticaEnviosPage';
import { TerminosPage } from '../pages/public/TerminosPage';
import { CatalogoPage } from '../pages/public/CatalogoPage';
import { ProductoDetallePage } from '../pages/public/ProductoDetallePage';
import { CarritoPage } from '../pages/public/CarritoPage';
import { CheckoutPage } from '../pages/public/CheckoutPage';
import { LoginPage } from '../pages/admin/LoginPage';
import { OlvidePasswordPage } from '../pages/admin/OlvidePasswordPage';
import { CambiarPasswordPage } from '../pages/admin/CambiarPasswordPage';
import { DashboardPage } from '../pages/admin/DashboardPage';
import { ProductosAdminPage } from '../pages/admin/ProductosAdminPage';
import { CategoriasAdminPage } from '../pages/admin/CategoriasAdminPage';
import { PedidosAdminPage } from '../pages/admin/PedidosAdminPage';
import { CuentasAdminPage } from '../pages/admin/CuentasAdminPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'sobre-nosotros', element: <SobreNosotrosPage /> },
      { path: 'contacto', element: <ContactoPage /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'politica-de-envios', element: <PoliticaEnviosPage /> },
      { path: 'terminos', element: <TerminosPage /> },
      { path: 'catalogo', element: <CatalogoPage /> },
      { path: 'catalogo/:id', element: <ProductoDetallePage /> },
      { path: 'carrito', element: <CarritoPage /> },
      { path: 'checkout', element: <CheckoutPage /> },
    ],
  },
  { path: '/admin/login', element: <LoginPage /> },
  { path: '/admin/olvide-password', element: <OlvidePasswordPage /> },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'catalogo', element: <ProductosAdminPage /> },
      { path: 'categorias', element: <CategoriasAdminPage /> },
      { path: 'pedidos', element: <PedidosAdminPage /> },
      { path: 'cuentas', element: <CuentasAdminPage /> },
      { path: 'cambiar-password', element: <CambiarPasswordPage /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
